"use client";

import type { FC, Ref } from "react";
import { Section, type SectionProps } from "@huub-web/shared";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface SectionTemplateProps {
  templates: TemplateCollection;
  variant?: SectionProps["variant"];
  edge?: SectionProps["edge"];
}

/**
 * SectionTemplate component
 *
 * @param props - SectionTemplate props
 * @returns JSX element
 */
export const SectionTemplate: FC<
  SectionTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, variant = "default", edge, ref }) => (
  <Section
    ref={ref}
    variant={variant}
    edge={edge === "none" ? "none" : undefined}
  >
    <TemplatesParser templates={templates} level={0} />
  </Section>
);
